import React from 'react';
import { isNullOrUndefined } from '../../../../../services/util';

export default function SubScoreTable(props) {
  const {subscores, t} = props;

  if (!subscores) return null;

  return (
    <table>
      <thead>
        <tr>
          <th>{t("Domain")}</th>
          <th>{t("PR")}</th>
          <th>{t("Status")}</th>
          <th>{t("Description")}</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(subscores).map(domain => {
          const subscore = subscores[domain];
          const {percentile, statusText, label} = subscore;
          if (isNullOrUndefined(percentile)) return null;
          return (
            <tr key={domain}>
              <td>{t(label, {ns: 'teacher_parent_report'})}</td>
              <td>{percentile}</td>
              <td>{statusText}</td>
              <td>{t(`domain_descriptions.${label}`, {ns: 'teacher_parent_report'})}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  )
}